export enum AnimalOriginReasonForTransfer {
  BORN_IN_SHELTER = 'born_in_shelter',
  DELIVERY = 'delivery',
  ENSURING = 'ensuring',
  FOUND_ANIMAL = 'found_animal',
  WILD_FOUND = 'wild_found',
  TAKEOVER_FROM_ANOTHER_SHELTER = 'takeover_from_another_shelter',
  REHOMING = 'rehoming',
  TAKE_AWAY = 'take_away',
  RESUMPTION_AFTER_TRIAL = 'resumption_after_trial',
  SECURED_BY_POLICE = 'secured_by_police',
}
